<template>
  <div class="modal modal-friends" id="friendsModal" @click="closeModal">
    <div class="modal-wrap">
      <div class="sheet-panel">
        <div class="sheet-header">
          <h3>Friends</h3>
          <button @click="$toggleFriendsModal()" class="close-modal">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <div class="sheet-content">
          <form v-on:submit.prevent>
            <div class="row invite">
              <div class="col-6 col-md-9">
                <input
                  type="email"
                  v-model="inviteEmailAddress"
                  placeholder="Email address"
                  class="form-control"
                />
              </div>
              <div class="col-6 col-md-3">
                <button
                  @click="inviteFriend()"
                  class="btn btn-primary btn-loader"
                  :class="{ active: loading }"
                >
                  <span>Invite friend</span>
                </button>
              </div>
            </div>
          </form>

          <div v-if="!getFriends.length" class="row friends">
            <div class="col-12 no-friends">
              <img src="@/assets/no_friends.svg" />
              <div class="content">
                <h4>You have no friends yet</h4>
                <p>Let's invite some friends!</p>
              </div>
            </div>
          </div>
          <div class="scroll-container">
            <div
              v-if="pendingFriends.length"
              class="row friends friends-pending"
            >
              <div class="col-12">
                <h6>Pending</h6>
              </div>
              <div
                v-bind:key="friend.id"
                v-for="friend in pendingFriends"
                class="col-md-6"
              >
                <div :id="friend.id" class="friend">
                  <div class="friend-avatar">
                    <img src="@/assets/img/avatar.png" class="squirkle" alt />
                  </div>
                  <div class="friend-content">
                    <span class="name">{{ friend.emailAddress }}</span>
                    <span v-if="!friend.status" class="status">Pending</span>
                    <div
                      v-if="friend.inviter && !friend.status"
                      class="actions"
                    >
                      <button
                        @click="rejectFriend(friend.id)"
                        class="btn btn-action btn-reject"
                      >
                        Cancel
                      </button>
                    </div>
                    <div
                      v-if="!friend.inviter && !friend.status"
                      class="actions"
                    >
                      <button
                        @click="acceptFriend(friend.id)"
                        class="btn btn-action btn-accept"
                      >
                        Accept
                      </button>
                      <button
                        @click="rejectFriend(friend.id)"
                        class="btn btn-action btn-reject"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeFriends.length" class="row friends friends-active">
              <div class="col-6 my-auto">
                <h6>Active friends</h6>
              </div>
              <div class="col-6 text-right">
                <button
                  class="toggle"
                  v-bind:class="{ active: manageFriends }"
                  v-on:click="manageFriends = !manageFriends"
                >
                  <span class="label">Manage</span>
                  <span class="switcher"> </span>
                </button>
              </div>

              <div
                v-bind:key="friend.id"
                v-for="friend in activeFriends"
                class="col-md-6"
              >
                <div :id="friend.id" class="friend">
                  <div class="friend-avatar">
                    <img src="/avatar.png" class="squirkle" alt />
                  </div>
                  <div class="friend-content">
                    <span class="name">{{ friend.emailAddress }}</span>
                    <span class="status green">Friends</span>
                    <div
                      class="actions"
                      v-bind:class="{ disabled: !manageFriends }"
                    >
                      <button
                        @click="rejectFriend(friend.id)"
                        class="btn btn-action btn-reject"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
var _ = require("lodash");

export default {
  name: "FriendsModal",
  components: {},
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
    pendingFriends() {
      return _.filter(this.getFriends, { status: false });
    },
    activeFriends() {
      return _.filter(this.getFriends, { status: true });
    }
  },
  data() {
    return {
      inviteEmailAddress: "",
      loading: false,
      manageFriends: false,
      dropDowns: {
        profile: { open: false },
        notifications: { open: false }
      }
    };
  },
  mounted: function() {},
  methods: {
    acceptFriend(friendId) {
      var acceptFriend = firebase.functions().httpsCallable("acceptFriend");
      let element = document.getElementById(friendId);
      element.classList.add("accepted");
      acceptFriend({
        friendId: friendId
      })
        .then(function(result) {
          console.log(result);
        })
        .catch(function(error) {
          var message = error.message;
          console.log(message);
        });
    },
    rejectFriend(friendId) {
      var rejectFriend = firebase.functions().httpsCallable("rejectFriend");
      let element = document.getElementById(friendId);
      element.classList.add("removed");

      rejectFriend({
        friendId: friendId
      })
        .then(function() {
          //console.log(result);
        })
        .catch(function(error) {
          var message = error.message;
          console.log(message);
        });
    },
    closeModal(e) {
      if (e.target.id == "friendsModal") {
        this.$toggleFriendsModal();
      }
    },
    inviteFriend() {
      const userEmailAddress = this.getUser.email;
      const firstName = this.getUserData.firstName;
      const lastName = this.getUserData.lastName;

      if (this.loading) {
        return false;
      }

      // Check that email is valid
      if (!this.$isValidEmailAddress(this.inviteEmailAddress)) {
        this.$toast.open({
          message: "Email is not valid",
          type: "error"
        });
        return false;
      }

      // Check that email is not user email
      if (this.inviteEmailAddress == userEmailAddress) {
        this.$toast.open({
          message: "You can't invite yourself",
          type: "error"
        });
        return false;
      }

      // Check that email is not already in the friends list
      var flag = false;
      this.getFriends.forEach(friend => {
        if (this.inviteEmailAddress == friend.emailAddress) {
          flag = true;
        }
      });

      if (flag) {
        this.$toast.open({
          message: "Friend request already sent",
          type: "error"
        });
        return false;
      }

      var inviteFriend = firebase.functions().httpsCallable("inviteFriend");
      this.loading = true;
      inviteFriend({
        inviteEmailAddress: this.inviteEmailAddress,
        userEmailAddress: userEmailAddress,
        firstName: firstName,
        lastName: lastName
      })
        .then(() => {
          this.$toast.open({
            message: "Invite sent to " + this.inviteEmailAddress,
            type: "success"
          });
          this.inviteEmailAddress = "";
          this.loading = false;
        })
        .catch(error => {
          this.$toast.open({
            message: error.message,
            type: "error"
          });
          this.loading = false;
        });
    }
  }
};
</script>
